import { Card, CardContent, Typography, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useTranslation } from "react-i18next";

interface CertificationsProps {
  certifications: string[];
}

export function Certifications({ certifications }: CertificationsProps) {
  const { t } = useTranslation();

  return (
    <section className="mb-8">
      <Typography variant="h3" className="text-2xl font-semibold mb-4">
        {t("certifications")}
      </Typography>
      <Card className="hover:shadow-2xl">
        <CardContent>
          <List className="grid grid-cols-1 md:grid-cols-2 gap-2">
            {certifications.map((cert, index) => (
              <ListItem key={index} disablePadding>
                <ListItemIcon>
                  <CheckCircleOutlineIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary={cert} />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>
    </section>
  );
}
